import React from "react";

/**
 * Global cinematic background:
 * - A dark cyberpunk image with strong overlays
 * - Subtle animated grid
 * - Floating glow orbs (cyan / magenta / yellow)
 * - Vertical HUD scan line
 */
const BackgroundFX = () => {
  return (
    <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden" aria-hidden="true">
      {/* Skyline image layer */}
      <div
        className="absolute inset-0 opacity-[0.22]"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1605747395244-fe828901171a?auto=format&fit=crop&w=2400&q=70')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "saturate(1.4) hue-rotate(180deg) contrast(1.1)",
        }}
      />
      {/* Heavy base gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#05050A]/80 via-[#05050A]/85 to-[#05050A]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(0,240,255,0.08),transparent_55%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_right,rgba(255,0,255,0.06),transparent_55%)]" />

      {/* Grid */}
      <div className="absolute inset-0 grid-bg opacity-60" />

      {/* Floating orbs */}
      <div className="absolute -top-40 -left-40 w-[520px] h-[520px] rounded-full blur-3xl opacity-30"
        style={{ background: "radial-gradient(circle, #00F0FF, transparent 60%)" }} />
      <div className="absolute top-1/3 -right-40 w-[480px] h-[480px] rounded-full blur-3xl opacity-20"
        style={{ background: "radial-gradient(circle, #FF00FF, transparent 60%)" }} />
      <div className="absolute bottom-0 left-1/3 w-[380px] h-[380px] rounded-full blur-3xl opacity-[0.12]"
        style={{ background: "radial-gradient(circle, #FFDE00, transparent 60%)" }} />

      {/* Scan beam */}
      <div className="scan-line" />
    </div>
  );
};

export default BackgroundFX;
